<script setup lang="ts">
import VExpansionPanel from '@/shared/ui/VExpansionPanel.vue';
import { FieldLabel, IntlTelInput } from '@/shared/ui';
import { ADMIN_RELATIONSHIP_OPTIONS } from '../model/relationshipOptions';

defineProps<{
    /** バリデーションエラー */
    errors?: {
        reservationHolderName?: string[];
        userName?: string[];
        relationshipWithGuest?: string[];
        email?: string[];
        phoneNumber?: string[];
        isPhoneValid?: string[];
        countryName?: string[];
    };
}>();

const reservationHolderName = defineModel<string>('reservationHolderName', { required: true });
const userName = defineModel<string>('userName', { required: true });
const relationshipWithGuest = defineModel<string>('relationshipWithGuest', { required: true });
const email = defineModel<string>('email', { required: true });
const phoneNumber = defineModel<string | undefined>('phoneNumber');
const isPhoneValid = defineModel<boolean>('isPhoneValid', { required: true });
const countryName = defineModel<string | undefined>('countryName');
</script>

<template>
    <VExpansionPanel title="申込者" :default-open="true">
        <div class="edit-panel-content">
            <div class="edit-panel-row">
                <FieldLabel label="宿泊予約者名" />
                <v-text-field
                    v-model="reservationHolderName"
                    variant="outlined"
                    density="compact"
                    placeholder="Taro Yamada"
                    :error-messages="errors?.reservationHolderName"
                    :hide-details="!errors?.reservationHolderName"
                />
            </div>

            <div class="edit-panel-row">
                <FieldLabel label="利用者名" />
                <v-text-field
                    v-model="userName"
                    variant="outlined"
                    density="compact"
                    placeholder="Hanako Yamada"
                    :error-messages="errors?.userName"
                    :hide-details="!errors?.userName"
                />
            </div>

            <div class="edit-panel-row">
                <FieldLabel label="宿泊者との関係" />
                <v-select
                    v-model="relationshipWithGuest"
                    :items="ADMIN_RELATIONSHIP_OPTIONS"
                    variant="outlined"
                    density="compact"
                    placeholder="選択してください"
                    :error-messages="errors?.relationshipWithGuest"
                    :hide-details="!errors?.relationshipWithGuest"
                />
            </div>

            <div class="edit-panel-row">
                <FieldLabel label="メールアドレス" />
                <v-text-field
                    v-model="email"
                    type="email"
                    variant="outlined"
                    density="compact"
                    placeholder="airtrunk@example.com"
                    :error-messages="errors?.email"
                    :hide-details="!errors?.email"
                />
            </div>

            <div class="edit-panel-row">
                <IntlTelInput
                    v-model:phone-number="phoneNumber"
                    v-model:country-name="countryName"
                    v-model:is-phone-valid="isPhoneValid"
                    label="電話番号"
                    :error-messages="errors?.phoneNumber ?? errors?.isPhoneValid"
                />
            </div>
        </div>
    </VExpansionPanel>
</template>

<style scoped>
.edit-panel-content {
    padding: 16px;
    background-color: #fafafa;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.edit-panel-row {
    display: flex;
    flex-direction: column;
    gap: 4px;
}
</style>
